<template>
    <real-estate-leaflet-map-ortofoto-communal-equipment
        class="property-iq__comunal-equipment-map-div"
        :gursSessionId="$store.state.gursSessionId"
        :height="400"
        :fullscreen="true"
        :zoom="19"
        :minZoom="17"
        :maxZoom="20"
        :lat="realEstate.gps.lat"
        :lng="realEstate.gps.lng"
        :polygons="polygons"
        :layersToInclude="communalEquipmentLayersToInclude"
        ref="communalEquipmentMap"
    >
        <template v-slot:popup_content_polygon="slotProps">
            <div class="p-10" style="white-space: nowrap;">{{ $t('property_iq:parcel')}} {{slotProps.polygon.property_id}}</div>
        </template>

        <template v-slot:markers>
            <l-marker
                v-if="marker"
                :lat-lng="marker.coordinates"
                :icon="house_icon"
            >
                <l-popup
                    :options="{autoPan: true}"
                >
                    <div class="p-10">{{realEstate.address}}</div>
                </l-popup>
            </l-marker>
        </template>
        
    </real-estate-leaflet-map-ortofoto-communal-equipment>
</template>

<script>
import L from 'leaflet';

import { LPopup, LMarker } from 'vue2-leaflet';

import RealEstateLeafletMapOrtofotoCommunalEquipment from "@apps/real_estate/vue/webcomponents/RealEstateLeafletMapOrtofotoCommunalEquipment.vue";

export default {
    components: {
        LPopup, LMarker,
        "real-estate-leaflet-map-ortofoto-communal-equipment": RealEstateLeafletMapOrtofotoCommunalEquipment
    },
    props: {
        realEstate: Object,
        polygons: Array,
    },
    computed: {
        marker: function() {
            return { coordinates: this.realEstate.gps };
        },
        house_icon: function() {
            return L.icon({
                iconUrl: require('@/images/house.png'),
                iconSize: [60, 60],
                iconAnchor: [30, 60],
                popupAnchor:  [0, -60]
            });
        },
        // Map translated equipment names to actual layer names from allCommunalEquipmentList
        communalEquipmentLayersToInclude: function() {
            // Translation key to layer name mapping (based on Slovenian layer names)
            const translationToLayerName = {
                [this.$t('property_iq:equipment:electricity')]: "Električna energija",
                [this.$t('property_iq:equipment:communication')]: "Komunikacije",
                [this.$t('property_iq:equipment:sewage')]: "Kanalizacija",
                [this.$t('property_iq:equipment:trash')]: "Odpadki",
                [this.$t('property_iq:equipment:water_infrastructure')]: "Vodna infrastruktura",
                [this.$t('property_iq:equipment:water_system')]: "Vodovod",
                [this.$t('property_iq:equipment:gas')]: "Zemeljski plin",
                [this.$t('property_iq:equipment:heating_energy')]: "Toplotna energija",
            };
            
            // Get the translated names
            const translatedNames = [
                this.$t('property_iq:equipment:electricity'),
                this.$t('property_iq:equipment:communication'),
                this.$t('property_iq:equipment:sewage'),
                this.$t('property_iq:equipment:trash'),
                this.$t('property_iq:equipment:water_infrastructure'),
                this.$t('property_iq:equipment:water_system'),
                this.$t('property_iq:equipment:gas'),
                this.$t('property_iq:equipment:heating_energy')
            ];
            
            // Map to actual layer names
            return translatedNames.map(translatedName => translationToLayerName[translatedName]).filter(Boolean);
        }
    }
}
</script>

<style>
.property-iq__comunal-equipment-map-div .leaflet-bottom.leaflet-left .leaflet-control {
    background-color: rgba(255, 255, 255, 0.473);
    margin: 0;
}
.leaflet-legend__icon,
.leaflet-legend__icon {
    vertical-align: middle;
    display: inline-block;
}
</style>
